import type { AppCatalogEntry } from '@api/apps';
import type { UserAppSummary } from '@api/appBuilder';
import { canDuplicate, canEdit, type AppOwnership } from '../appPermissions';
import { isRunnable } from './userAppStatus';

export type GalleryActionId = 'edit' | 'duplicate' | 'share' | 'unshare' | 'turnOffLink' | 'delete';

const ADMIN_ROLES: ReadonlySet<string> = new Set(['ORG_ADMIN', 'AIBUILD_ADMIN']);

export const isOrgAdmin = (orgRole: string | null | undefined): boolean =>
  orgRole != null && ADMIN_ROLES.has(orgRole);

export const ownershipOfMine = (app: UserAppSummary): AppOwnership => ({
  source: 'USER',
  ownedByMe: true,
  visibility: app.visibility,
});

const copyable = (app: UserAppSummary): boolean =>
  canDuplicate(ownershipOfMine(app)) && app.status !== 'DISABLED';

export const myAppActions = (app: UserAppSummary): GalleryActionId[] => {
  const ids: GalleryActionId[] = [];
  if (canEdit(ownershipOfMine(app))) ids.push('edit');
  if (copyable(app)) ids.push('duplicate');
  if (isRunnable(app)) ids.push(app.visibility === 'ORG' ? 'unshare' : 'share');
  if (app.publicLink) ids.push('turnOffLink');
  ids.push('delete');
  return ids;
};

export const sharedAppActions = (entry: AppCatalogEntry, orgAdmin: boolean): GalleryActionId[] => {
  const ids: GalleryActionId[] = [];
  if (canEdit(entry)) ids.push('edit');
  if (canDuplicate(entry)) ids.push('duplicate');
  if (orgAdmin && entry.source === 'USER' && entry.visibility === 'ORG') ids.push('unshare');
  if (orgAdmin && entry.publicLink) ids.push('turnOffLink');
  return ids;
};
